<template>
  <div>
    <v-container fluid pa-0 v-show="showComponent">
      <TopBoardCategories
        :header="constants.Keys[0].KeyValue.Value"
        :subHeader="constants.Keys[1].KeyValue.Value"
        :showSearch="false"
        :class="'calculator'"
      />
      <div class="section_inner pa-3 pr-3 pr-lg-0">
        <v-row>
          <v-col cols="12" md="9" sm="12">
            <v-row>
              <v-col cols="12">
                <div
                  class="display-22-16"
                  v-html="constants.Keys[2].KeyValue.Value"
                ></div>
              </v-col>
              <v-col cols="12">
                <iframe
                  src="https://shakoof.org.il/salarycalculator/"
                  frameborder="0"
                  width="100%"
                  :height="setHeight"
                  backgroundC
                ></iframe>
              </v-col>
              <v-col cols="12">
                <p class="display-16 text-center">
                  מחשבון זה בחסות
                  <a
                    href="https://shakoof.org.il/"
                    target="_blank"
                    title="שקוף - פורטל פיננסי "
                  >
                    שקוף - פורטל פיננסי
                  </a>
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <SectionCompaniesInnerPages
              :is-hitech="false"
              :page="'calculatorPage'"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
    
    
<script>
import TopBoardCategories from '@/components/CategoriesPage/TopBoardCategories';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import DeviceDetect from '@/components/mixins/DeviceDetect';
import { CALCULATOR_DATA } from '@/lib/api.js';
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';

export default {
  name: 'articlePage',
  mixins: [SeoOptimization, DeviceDetect],
  components: {
    TopBoardCategories,
    SectionCompaniesInnerPages,
  },
  data() {
    return {
      showComponent: false,
      constants: {},
      iframeHeight: 400,
    };
  },
  async asyncData({ error, $axios }) {
    return await $axios
      .get(`${CALCULATOR_DATA}`)
      .then((response) => {
        if (response.IsError) {
          throw 'שגיאת מערכת ';
        }
        return {
          showComponent: true,
          constants: response.data.Constants,
          seodata: {
            metaData: response.data.SEO.MetaDataItems,
            pageTitle: response.data.SEO.title,
            canonicalUrl: response.data.SEO.CanonicalUrl,
          },
        };
      })
      .catch((e) => {
        error({ statusCode: 404, message: 'calculator page error: ' + e });
      });
  },
  head() {
    return {
      link: [{ rel: 'canonical', href: this.seodata.canonicalUrl }],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
    };
  },

  computed: {
    setHeight() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 1000;
      } else {
        return 400;
      }
    },
  },
  mounted() {
    // run scroll to top after timeout for better performance (avoid reflow)
    window.scrollTo(0, 0);
  },
};
</script>

<style >
iframe body {
  background: red;
}
</style>
